'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _commonjsHelpers = require('./_commonjsHelpers-1b94f6bc.js');
var index_es = require('./index.es-1f72f6f2.js');
var index$4 = require('./index-c25ba35c.js');

var AVATAR_MAX_WIDTH = '32px';
var CONTAINER_WIDTH = '11em';
var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  height: 100%;\n  width: ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor: pointer;\n"], ["\n  height: 100%;\n  width: ",
    ";\n  color: ", ";\n  background-color: ", ";\n  cursor: pointer;\n"])), function (_a) {
    var withAvatar = _a.withAvatar;
    return (withAvatar
        ? CONTAINER_WIDTH
        : "calc(" + CONTAINER_WIDTH + " - " + AVATAR_MAX_WIDTH + ")");
}, function (props) { return props.color; }, function (props) { return props.backgroundColor; });
var Icon = styled__default(index_es.FontAwesomeIcon)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  width: 9px !important;\n"], ["\n  width: 9px !important;\n"])));
var Button = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 7px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 24px;\n\n  ", " {\n    margin-left: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 7px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 18px;\n  line-height: 24px;\n\n  ", " {\n    margin-left: ", ";\n  }\n"])), function (_a) {
    var withAvatar = _a.withAvatar;
    return (withAvatar ? 'space-between' : 'flex-end');
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, Icon, function (_a) {
    var withAvatar = _a.withAvatar;
    return (withAvatar ? 'inherit' : '15px');
});
var Image = styled__default.img(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  height: auto;\n  width: 100%;\n  max-width: ", ";\n  border-radius: 50%;\n"], ["\n  height: auto;\n  width: 100%;\n  max-width: ", ";\n  border-radius: 50%;\n"])), AVATAR_MAX_WIDTH);
var Content = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  display: ", ";\n  width: ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  border: ", ";\n  box-sizing: border-box;\n  box-shadow: 0px 4px 4px rgba(45, 51, 56, 0.2);\n  z-index: 11;\n  right: 1em;\n\n  @media (min-width: ", ") {\n    right: 3em;\n  }\n"], ["\n  position: absolute;\n  display: ", ";\n  width: ", ";\n  border-radius: 4px;\n  background-color: ", ";\n  border: ", ";\n  box-sizing: border-box;\n  box-shadow: 0px 4px 4px rgba(45, 51, 56, 0.2);\n  z-index: 11;\n  right: 1em;\n\n  @media (min-width: ", ") {\n    right: 3em;\n  }\n"])), function (props) { return (props.isOpen ? 'block' : 'none'); }, CONTAINER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
}, function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.colors.$greyLight;
}, constants.DIMENSIONS.MEDIUM);
var Item = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: 38px;\n  margin-top: ", ";\n  margin-bottom: 6px;\n  padding-left: 16px;\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 22px;\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  height: 38px;\n  margin-top: ", ";\n  margin-bottom: 6px;\n  padding-left: 16px;\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 22px;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) { return (props.index === constants.FIRST_ITEM_INDEX ? '6px' : '0px'); }, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$greyLight;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var _extends_1 = _commonjsHelpers.createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _extends = /*@__PURE__*/_commonjsHelpers.unwrapExports(_extends_1);

var objectWithoutPropertiesLoose = _commonjsHelpers.createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _objectWithoutPropertiesLoose = /*@__PURE__*/_commonjsHelpers.unwrapExports(objectWithoutPropertiesLoose);

var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  ref.current = value;
};

var useComposedRef = function useComposedRef(libRef, userRef) {
  var prevUserRef = React.useRef();
  return React.useCallback(function (instance) {
    libRef.current = instance;

    if (prevUserRef.current) {
      updateRef(prevUserRef.current, null);
    }

    prevUserRef.current = userRef;

    if (!userRef) {
      return;
    }

    updateRef(userRef, instance);
  }, [userRef]);
};

var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}

var castArray = function castArray(value) {
  return Array.isArray(value) ? value : [value];
};

var useOuterClick = function useOuterClick(refs, handler) {
  !(Array.isArray(refs) || typeof refs === 'object' && refs !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected `refs` to be an array or object') : invariant(false) : void 0;

  if (Array.isArray(refs)) {
    !(refs.length > 0) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected `refs` to to not be empty') : invariant(false) : void 0;
    refs.forEach(function (ref, i) {
      !(typeof ref === 'object' && ref !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Expected `refs[" + i + "]` to be an object") : invariant(false) : void 0;
    });
  }

  !(typeof handler === 'function' || handler == null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Expected `handler` to be a function') : invariant(false) : void 0;
  var eventListenerRef = React.useRef();
  React.useEffect(function () {
    eventListenerRef.current = function (event) {
      if (castArray(refs).every(function (ref) {
        return !ref.current || ref.current !== event.target && !ref.current.contains(event.target);
      })) {
        handler == null ? void 0 : handler(event);
      }
    };
  }, [handler, refs]);
  React.useEffect(function () {
    var eventListener = function eventListener(event) {
      eventListenerRef.current(event);
    };

    ['mousedown', 'touchstart'].forEach(function (type) {
      document.addEventListener(type, eventListener, true);
    });
    return function () {
      ['mousedown', 'touchstart'].forEach(function (type) {
        document.removeEventListener(type, eventListener, true);
      });
    };
  }, []);
};

var OuterClick = /*#__PURE__*/React.forwardRef(function OuterClick(_ref, userRef) {
  var _ref$as = _ref.as,
      Element = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$onOuterClick = _ref.onOuterClick,
      onOuterClick = _ref$onOuterClick === void 0 ? null : _ref$onOuterClick,
      rest = _objectWithoutPropertiesLoose(_ref, ["as", "children", "onOuterClick"]);

  var libRef = React.useRef();
  var ref = useComposedRef(libRef, userRef);
  useOuterClick(libRef, onOuterClick);
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    ref: ref
  }), children);
});
OuterClick.propTypes = process.env.NODE_ENV !== "production" ? {
  as: index$4.propTypes.elementType,
  children: index$4.propTypes.node,
  onOuterClick: index$4.propTypes.func
} : {};

exports.Button = Button;
exports.Container = Container;
exports.Content = Content;
exports.Icon = Icon;
exports.Image = Image;
exports.Item = Item;
exports.useOuterClick = useOuterClick;
